module.exports = __webpack_public_path__ + "static/enterprise-7140b30c45725828d351f437a99216a1.png";